import GeofencesMap from './GeofencesMap';
import RowResumeText from './../../../../../components/RowResumeText';
import CustomDaySelector from '../../../../../components/CustomDaySelector';
import DividerWithText from '../../../../../components/DividerWithText';
import React from "react";
import SummaryDetailsTrafficGeofence from "./SummaryDetailsTrafficGeofence";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const GeofenceSummary = ({ item, dayArray, t, geofences, center}) => {
    return (
        <div className='row mb-5'>
            <DividerWithText title={t('details')} />
            <div className='d-flex justify-content-center'>
                <SummaryDetailsTrafficGeofence item={item}/>
            </div>
            <DividerWithText title={t('active_schedule')} />
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-12 p-0'>
                        <div className='d-flex justify-content-end mb-4'>
                            <CustomDaySelector dayArray={dayArray} setDayArray={() => {}} readonly={true} />
                        </div>
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                        <RowResumeText title={t('from')} value={item?.opening} className='mb-4' />
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                        <RowResumeText title={t('to')} value={item?.closing} className='mb-4' />
                    </div>
                </div>
            </div>
            <DividerWithText title={t('geofences')} />
            <div className='d-flex justify-content-center'>
                <div className='col-8 mt-4'>
                    <GeofencesMap
                        center={center}
                        geofences={geofences}
                        geofenceTitle='defined_areas'
                        showTitle={false}
                        classNameMap={"h-500px"}
                    />
                </div>
            </div>
        </div>
    );
};

export default GeofenceSummary;
